import { createApp } from "vue";
import "./assets/styles/globals.css";
import "./assets/styles/app.scss";
import ZeusLoader from "@/components/ui/ZeusLoader.vue";
import App from "./App.vue";
import { createPinia } from "pinia";
import { installGlobalErrorReporting } from "@/lib/analytics";
import { applyDocumentLang } from "@/lib/documentLang";
import { router } from "@/router";

const THEME_STORAGE_KEY = "cardgenius.theme";
const THEME_MODE_STORAGE_KEY = "cardgenius.theme-mode";

function preApplyThemeFromLocalStorage() {
  try {
    const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === "dark" || stored === "light") {
      document.documentElement.classList.toggle("dark", stored === "dark");
      return;
    }
  } catch {
    // ignore
  }
}

/** Dev convenience: open `/?theme=dark` or `/?theme=light` to seed localStorage before Pinia mounts. */
function preApplyThemeBeforeMount() {
  try {
    const params = new URLSearchParams(window.location.search);
    const themeParam = params.get("theme");
    if (themeParam === "dark" || themeParam === "light") {
      window.localStorage.setItem(THEME_STORAGE_KEY, themeParam);
      window.localStorage.setItem(THEME_MODE_STORAGE_KEY, themeParam);
      document.documentElement.classList.toggle("dark", themeParam === "dark");
      return;
    }
  } catch {
    // ignore
  }
  preApplyThemeFromLocalStorage();
}

const app = function (mountSelector = "#app") {
  preApplyThemeBeforeMount();
  applyDocumentLang();
  const mountEl = document.querySelector(mountSelector);
  if (!mountEl) return;

  const app = createApp(App);

  const pinia = createPinia();
  app.use(pinia);
  app.use(router);
  installGlobalErrorReporting(app);
  app.component("ZeusLoader", ZeusLoader);

  router.isReady().then(() => {
    app.mount(mountSelector);
  });
};

export default app;
